var render, staticRenderFns
import script from "./DepartAddrSettingPrototype.vue?vue&type=script&lang=js&"
export * from "./DepartAddrSettingPrototype.vue?vue&type=script&lang=js&"
import style0 from "./DepartAddrSettingPrototype.vue?vue&type=style&index=0&id=00104d49&prod&lang=css&"
import style1 from "@assets/css/enterprise_settings_page.css?vue&type=style&index=1&id=00104d49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00104d49",
  null
  
)

export default component.exports